import ImpersonationApi from '../../api/impersonationApi'
import { ImpersonationUser } from '../../types/api/impersonation'
import { OptionalParamsApi, OptionsTypeReactQuery, PaginationResponseSecondFormat } from '../../types/api'
import useCustomQuery from './useCustomQuery'

export enum ImpersonationServerStateKeysEnum {
  Users = 'impersonation_users',
}

export const useGetImpersonationUsersQuery = (
  params: OptionalParamsApi,
  regionId = '99',
  options?: OptionsTypeReactQuery<PaginationResponseSecondFormat<ImpersonationUser>>,
) =>
  useCustomQuery<PaginationResponseSecondFormat<ImpersonationUser>, Error>(
    [ImpersonationServerStateKeysEnum.Users, params, regionId],
    async (header) => await ImpersonationApi.getUsers(params, header, regionId),
    options,
  )
